import { useMemo, useState } from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { ImageCarousel } from '@odo/shared-ui';
import type { MarkupPhoto } from '../actions/dm/scanMarkup/scanPhotoOptions';

export interface OpenedPhotos {
    title: string;
    photos: MarkupPhoto[];
    index: number;
}

interface RejectedScanPhotoViewerProps {
    opened: OpenedPhotos;
    onBack: () => void;
}

function RejectedScanPhotoViewer({ opened, onBack }: RejectedScanPhotoViewerProps) {
    const [index, setIndex] = useState(opened.index);
    const { images, labels, thumbnails } = useMemo(
        () => ({
            images: opened.photos.map((photo) => photo.fullUrl),
            thumbnails: opened.photos.map((photo) => photo.thumbnailUrl),
            labels: opened.photos.map(
                (photo, i) => `${photo.label} ${i + 1}/${opened.photos.length}`
            )
        }),
        [opened.photos]
    );

    return (
        <div className="flex h-full flex-col gap-3 px-6 py-4">
            <button
                type="button"
                onClick={onBack}
                className="inline-flex items-center gap-1.5 self-start text-sm font-semibold text-gray-600 hover:text-gray-800 transition-colors"
            >
                <ArrowLeftIcon className="h-4 w-4" />
                Back to scan
            </button>
            <p className="text-sm font-semibold text-gray-700">{opened.title}</p>
            <div className="flex-1 min-h-0">
                <ImageCarousel
                    images={images}
                    labels={labels}
                    thumbnails={thumbnails}
                    index={index}
                    onIndexChange={setIndex}
                />
            </div>
        </div>
    );
}

export { RejectedScanPhotoViewer };
